(() => {
 const init = (root) => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-browse-filters]'), grid = root.querySelector('[data-browse-grid]');
  const status = root.querySelector('[data-browse-status]'), pagination = root.querySelector('[data-browse-pagination]');
  const toggle = root.querySelector('[data-new-toggle]');
  const current = new URL(location.href), onlyNew = current.searchParams.get('tx_new') === '1';
  const withView = (href) => { const url = new URL(href, location.href); url.searchParams.set('view', 'hladanie'); url.searchParams.set('sort_by', 'created-descending'); if (onlyNew) url.searchParams.set('tx_new', '1'); return url; };
  root.querySelectorAll('[data-preserve-view],[data-load-more]').forEach(a => a.href = withView(a.href));
  const submit = () => {
   const url = new URL(form.action, location.href);
   for (const [key,value] of new FormData(form)) if (value !== '') url.searchParams.append(key,value);
   if (onlyNew) url.searchParams.set('tx_new','1');
   location.assign(url.href);
  };
  form.addEventListener('submit', event => { event.preventDefault(); submit(); });
  form.querySelectorAll('[data-auto-submit]').forEach(el => el.addEventListener('change',submit));
  let min = form.querySelector('[data-price-min-input]'), max = form.querySelector('[data-price-max-input]');
  if (!min || !max) {
   // Shopify can omit filters for very large collections. Hide unsupported price controls.
   form.querySelectorAll('[data-price-min],[data-price-max]').forEach(button => button.hidden = true);
  } else {
   form.querySelectorAll('[data-price-min],[data-price-max]').forEach(button => {
    const active = (button.dataset.priceMin || '') === min.value && (button.dataset.priceMax || '') === max.value;
    button.setAttribute('aria-pressed', String(active));
    button.addEventListener('click', () => { min.value = active ? '' : button.dataset.priceMin || ''; max.value = active ? '' : button.dataset.priceMax || ''; submit(); });
   });
  }
  const selects = [...form.querySelectorAll('[data-filter-select]')];
  selects.forEach(select => { if (select.options.length <= 1) select.parentElement.hidden = true; });
  const hasFilters = selects.some(select => select.options.length > 1) || !!form.querySelector('.tx-sizebar');
  if (!min || !max || !hasFilters) { const hint=document.createElement('p'); hint.className='tx-count'; hint.textContent='Filtre podľa značky, veľkosti, farby a ceny sa zobrazia po výbere oblasti (Obuv, Oblečenie, Doplnky, Zberateľské).'; form.prepend(hint); }
  toggle.setAttribute('aria-pressed', String(onlyNew));
  toggle.addEventListener('click', () => { const url = new URL(location.href); url.searchParams.delete('page'); if (onlyNew) url.searchParams.delete('tx_new'); else url.searchParams.set('tx_new','1'); location.assign(url.href); });
  const fetchDoc = async url => {
   const response = await fetch(url, {signal: AbortSignal.timeout(30000)});
   if (!response.ok) throw new Error('HTTP ' + response.status);
   return new DOMParser().parseFromString(await response.text(),'text/html');
  };
  if (onlyNew) {
   status.textContent = 'Hľadáme produkty pridané za posledných 7 dní…';
   grid.hidden = true; pagination.hidden = true;
   (async () => {
    const url = new URL(location.href); url.searchParams.delete('tx_new'); url.searchParams.delete('page'); url.searchParams.set('section_id','tx-new-products-feed');
    const get = async page => { const u = new URL(url); u.searchParams.set('page',page); const doc = await fetchDoc(u); const feed = doc.querySelector('[data-new-feed]'); if (!feed || Number(feed.dataset.page) !== page) throw new Error('Incomplete feed'); return feed; };
    const first = await get(1), pages = Math.max(1,Number(first.dataset.pages));
    const cards = [...first.querySelectorAll('.tx-card')];
    for (let i=2;i<=pages;i+=2) {
     const feeds = await Promise.all(Array.from({length:Math.min(2,pages-i+1)},(_,j)=>get(i+j)));
     feeds.forEach(feed => cards.push(...feed.querySelectorAll('.tx-card')));
    }
    grid.replaceChildren(); pagination.replaceChildren(); let visible = 0;
    const more = document.createElement('button'); more.type='button'; more.className='tx-fchip'; more.textContent='Načítať ďalšie';
    const show = () => { grid.append(...cards.slice(visible,visible+24)); visible+=24; more.hidden=visible>=cards.length; };
    more.addEventListener('click',show); pagination.append(more); show();
    status.textContent = cards.length + ' produktov pridaných za posledných 7 dní';
    if (!cards.length) { const empty=document.createElement('p'); empty.textContent='Pre tento výber sa nenašli novinky.'; grid.append(empty); }
    grid.hidden=false; pagination.hidden=false;
   })().catch(() => { status.textContent='Novinky sa nepodarilo načítať. Obnovte stránku alebo vypnite filter Len novinky.'; });
  } else {
   pagination.addEventListener('click', async event => {
    const link = event.target.closest('[data-load-more]'); if (!link) return;
    event.preventDefault(); if (link.dataset.loading) return;
    link.dataset.loading='true'; link.textContent='Načítava sa…';
    try {
     const doc=await fetchDoc(withView(link.href)); const nextGrid=doc.querySelector('[data-browse-grid]');
     if (!nextGrid) throw new Error('Missing grid');
     grid.append(...nextGrid.children);
     const next=doc.querySelector('[data-load-more]');
     if (next) { link.href=withView(next.getAttribute('href')); link.textContent='Načítať ďalšie'; delete link.dataset.loading; } else link.remove();
    } catch (_) { link.textContent='Skúsiť načítať znova'; delete link.dataset.loading; }
   });
  }
 };
 document.querySelectorAll('[data-tx-browse]').forEach(init);
 document.addEventListener('shopify:section:load',event => init(event.target.querySelector('[data-tx-browse]')));
})();
